const SITE_TO_DUSTIN_BASE_CONTRACT = {
  None: 0,
  DustinSweden: 1,
  DustinNorway: 3,
  DustinDenmark: 5,
  DustinFinland: 7,
  DustinNetherlands: 9,
  DustinBelgium: 11,
} as const

type SiteKey = keyof typeof SITE_TO_DUSTIN_BASE_CONTRACT

export const createOptimizelyUserAttributes = (
  site: string,
  punchOutTicket: string | null | undefined,
  isMobile: boolean,
  deviceType: string | null | undefined,
  userAgent: string | null | undefined,
  userData: Record<string, any>
) => ({
  Site: SITE_TO_DUSTIN_BASE_CONTRACT[site as SiteKey] ?? 0,
  IsPunchOut: !!punchOutTicket,
  IsMobile: isMobile,
  DeviceType: deviceType || null,
  ContactId: userData?.contact?.id || null,
  CustomerId: userData?.contact?.customerId || null,
  $opt_user_agent: userAgent || null,
})
